import type { OptionalLinkProps } from '@/components/OptionalLink';
import { OptionalLink } from '@/components/OptionalLink';
import type { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { MdLockOutline } from 'react-icons/md';
import { Tabs } from './Tabs';

interface ExtendedOptions {
  $link?: OptionalLinkProps['options'];
}

export interface StandaloneTabsProps extends StandaloneComponentProps<typeof Tabs, ExtendedOptions> {
  tabs?: (OptionalLinkProps & {
    isActive?: boolean;
    isLocked?: boolean;
  })[];
}

export const StandaloneTabs: StandaloneComponent<StandaloneTabsProps> = ({ tabs, ...props }) => {
  return (
    <Tabs {...props}>
      {(tabs ?? []).map(({ content, isActive, isLocked, ...link }, index) => {
        return (
          <Tabs.Tab key={index} data-active={isActive ? '' : undefined} data-locked={isLocked ? '' : undefined}>
            <OptionalLink {...link} options={props?.options?.$link}>
              {isLocked && <MdLockOutline />}
              {content}
            </OptionalLink>
          </Tabs.Tab>
        );
      })}
    </Tabs>
  );
};
